import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ITextButton } from './text-button.component.interface';

@Component({
    selector: 'mlp-ng-text-button-external-atom',
    templateUrl: './text-button-external.component.html',
    styleUrls: ['./text-button-external.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TextButtonExternalAtomSharedComponent implements OnInit {
    @Input() attributes: ITextButton['attributes'];
    @Input() label: ITextButton['label'];
    @Input() url: ITextButton['url'];
    @Input() icon: ITextButton['icon'];
    @Input() uppercase: ITextButton['uppercase'] = true;
    @Input() color: ITextButton['color'];

    @ViewChild('aTag') aTagElement: ElementRef<HTMLElement>;

    ngOnInit(): void {
        if (this.attributes) {
            Object.keys(this.attributes).forEach(key => {
                this.aTagElement.nativeElement.setAttribute(key, this.attributes[key]);
            });
        }

    }
}
